
import React, { useCallback, useEffect, useState } from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";
import { Feat, GameClass, Gift, SpellList, Subclass } from '@dndModels';
import LoadingBox from '@components/input/LoadingBox';
import DandDAPI from '@utilities/smart_api';
import { FeatureSource } from '@models';
import { DataType } from '@dndModels/Types';

const api = DandDAPI.getInstance();

export default function SpellListIndex() {
  const [fss, setFSs] = useState<FeatureSource[]>([]);
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);

  const load = useCallback( async () => {
    // live loads go into live_smart_hash (getLiveDataTypeFromHash), not the regular hash.
    // They're the full docs, so the feature bases are there, but each feature's
    // floating_feature still has to be connected for getSpellcastingFeature to find it.
    const fs_types: DataType[] = ["game_class","subclass","feat","gift"];
    let promises = fs_types.map(fs_type => api.loadDataType(fs_type, "priority", { live: true }));
    const waitForPromises = () => promises.length > 0 ? Promise.all(promises) : Promise.resolve();
    await waitForPromises();
    const new_fss = [
      ...api.getLiveDataTypeFromHash<GameClass>("game_class"),
      ...api.getLiveDataTypeFromHash<Subclass>("subclass"),
      ...api.getLiveDataTypeFromHash<Feat>("feat"),
      ...api.getLiveDataTypeFromHash<Gift>("gift")
    ];
    promises = new_fss.map(fs => api.loadObject(fs));
    await waitForPromises();
    setFSs(new_fss);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      if (api.user && api.user.admin) {
        setLoading(true);
        setTimeout(() => {
          load();
        }, 100);
      }
    }
  }, [fetched]);

  if (!fetched || loading) {
    return (<LoadingBox />);
  }

  const spellcastingFeatureMatches = (spell_list: SpellList, fs: FeatureSource) => {
    // if (spell_list.name === "Bard" && fs.name === "Bard") {
    //   debugger;
    // }
    const sf_features = fs.getSpellcastingFeatures();
    return sf_features.some(o => o.spell_list_ids.includes(spell_list._id));
  }

  return (
    <NonFSIndex
      data_type="spell_list"
      quick_fields={["source_book"]}
      // save_all
      extra_details={(obj) => {
        console.log(obj);
        if (obj instanceof SpellList && api.user && api.user.admin) {
          const in_fss = fss.filter(o => spellcastingFeatureMatches(obj, o));
          return in_fss.map(o => {
            return `${o.name} (${o.get_detail_format()})`;
          }).join(", ");
        }
        return "";
      }}
    />
  );
}
